<template>
  <div class="page">
    <div class="share-banner">
      <!--  -->
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, i) in banners" :key="i"><img :src="item.operationUrl" alt="" @click="bannerClick(item)"></van-swipe-item>
      </van-swipe>
    </div>
      <div class="page-header">
        <span class="page-header-text"><span>{{ projectName }}</span></span>
      </div>
      <ud-card class="page-info" :border-radius="9">
        <div class="page-date-row">
          <span class="page-date-row-title">通行证有效期：</span>
          <div class="page-date-row-list">
            <div class="page-date-row-list-item">
              <span class="page-date-row-list-item-text">{{ info.qrValidityStart }}</span>
            </div>
            <span class="page-date-row-list-line">-</span>
            <div class="page-date-row-list-item">
              <span class="page-date-row-list-item-text">{{ info.qrValidityEnd }}</span>
            </div>
          </div>
        </div>
        <div class="page-address-row">
          <span class="page-address-row-left">来访地址：</span>
          <span class="page-address-row-right">{{ info.houseNum }}</span>
        </div>
        <div class="page-access-control">
          <span class="page-access-control-title">已授权门禁：</span>
          <div class="page-access-control-list" >
            <door-item v-for="(item, index) in doorList" :text="item" :key="index" @refresh="init(id)"></door-item>
          </div>
          <ud-empty-row height="15" />
        </div>
      </ud-card>
      <ud-empty-row height="10" />
      <ud-card class="page-qrcode" :border-radius="9">
        <div class="page-qrcode-whole">
          <ud-empty-row height="22" />
          <span class="page-date-row-title">通行证二维码：</span>
          <ud-empty-row height="16" />
          <div class="qrcode" ref="qrCodeUrl"></div>
          <ud-empty-row height="19" />
          <span class="page-qrcode-whole-tips">包含通行证授权详情，可在需要时出示给运营管理方</span>
          <ud-empty-row height="30" />
        </div>
      </ud-card>
  </div>
</template>

<script>
import DoorItem from '@/components/door-item'
import { NetService } from '@/service'
import UdEmptyRow from '@/components/ud-empty-row'
import UdCard from '@/components/ud-card'
import { Dialog, Toast, Swipe, SwipeItem } from 'vant'
import Vue from 'vue'
import QRCode from 'qrcodejs2'

Vue.use(Swipe);
Vue.use(SwipeItem)

Vue.use(Dialog)
Vue.use(Toast)

export default {
  components: {
    DoorItem,
    UdEmptyRow,
    UdCard,
  },
  data() {
    return {
      doorList: [],
      info: true,
      list: null,
      projectName: '',
      banners: [],
      id: ''
    }
  },
  mounted() {
    let query = this.getURLParameters(window.location.href)
    let id = query.id
    this.id = id
    // this.projectId = query.projectId
    if (!id) {
      Dialog({ message: '出错了，请重试' })
    } else {
      this.init(id)
      // 生成二维码
        let type = 'FK'
        this.creatQrCode(JSON.stringify({ type, id }))
    }
    this.getBanners(id)
  },
  methods: {
    getBanners() {
      NetService.GetBanners({ isNormal: 1, operationPlaceType: 5, operationType: 2, visitorRegisterId: this.id}).then(res => {
        this.banners = res
      })
    },
    bannerClick(item) {
      NetService.AddClickRate(item.id).then(() => {
        switch (item.operationTargetType){
						case 0:
							break
						case 1:
              location.href = item.operationTargetUrl
							break
						case 2:
							break
						case 3:
							break
						case 4:
							break
						default:
							break
					}
      })
    },
    async init(id) {
      let loading = Toast.loading('加载中...')
      try {
        let res = await NetService.Visitor(`${id}`)
        this.info = res.cspVisitorRegister
        this.doorList = res.cspVisitorRegisterAuthorizeList || []
        this.projectName = res.projectName
        loading.clear()
      } catch(err) {
        loading.clear()
        Toast(err ? err.msg : '')
      }
    },
    getURLParameters(url) {
      return (url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(
        (a, v) => ((a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)), a), {}
      )
    },
    creatQrCode(text) {
      new QRCode(this.$refs.qrCodeUrl, {
        text,
        width: 260,
        height: 260,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.page {
  min-height: 100vh;
  background-color: #F6F6F6;
  .share-banner {
    margin: 20px;
    img {
      width: 100%;
      height: 226px;
    }
    .my-swipe {

    }
  }
  &-bg {
    width: 100vw;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
  &-header {
    padding: 0 20px;
    @extend .flex-row;
    align-items: center;
    &-text {
      @include text(32px, bold, #000);
      position: relative;
      &:before{
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 92px;
        height: 20px;
        background: linear-gradient(88deg, #FF8B5C 0%, rgba(255,139,92,0) 100%);
        border-radius: 2px;
        z-index: 0;
      }
      span {
        position: relative;
        z-index: 1;
      }
    }
  }
  &-info {
    border-radius: 4px;
    margin: 30px 20px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 12px;
    padding: 30px 30px 0;
  }
  &-date-row {
    padding: 0px 0 12px 0;
    border-bottom: 1px solid #F5F5F5;
    &-title {
      margin-bottom: 30px;
      @include text(32px, bold, $color-font);
      display: block;
    }
    &-list {
      @extend .flex-row;
      align-items: center;
      justify-content: space-between;
      &-line {
        @include text(21px, 400, #9B9B9B);
        margin: 0 10px;
      }
      &-item {
        width: 250px;
        height: 60px;
        border-radius: 1px;
        background-color: #F6F6F6;
        @extend .flex-row-center;
        border-radius: 6px;
        &-text {
          @include text(21px, 400, #9B9B9B);
        }
      }
    }
  }
  &-address-row {
    padding: 0 0;
    height: 80px;
    @extend .flex-row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #F5F5F5;
    &-left {
      @include text(32px, bold, $color-font);
    }
    &-right {
      @include text(24px, 400, $color-disabled);
    }
  }
  &-access-control {
    padding: 0 0;
    &-title {
      @include text(32px, bold);
    }
    &-list {
      @extend .flex-row;
      flex-wrap: wrap;
      display: block;
      &-item {
        margin-top: 12px;
      }
    }
  }
}
.nav-bar {
  @include relative(2);
}
.list-view {
  flex: 1;
  @include relative(2);
}
.page-qrcode {
    border-radius: 4px;
    // height: 700px;
    margin: 0px 20px;
    &-whole{
      @extend .flex-row;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      &-code {
        @include text(30px, bold);
      }
      &-btn {
        padding: 0 16px;
        height: 42px;
        background-color: rgba(255, 196, 110, 1);
        border-radius: 24px;
        @extend .flex-row-center;
        &-text {
          @include text(11px, 400, rgba(98, 62, 10, 1));
        }
      }
      &-pic {
        width: 256px;
        height: 256px;
      }
      &-refresh {
        height: 24px;
        padding: 0 12px;
        border: 1rpx solid $color-primary;
        @extend .flex-row-center;
        border-radius: 3rpx;
        &-text {
          @include text(11px, 400, $color-primary);
        }
      }
      &-tips {
        @include text(11px, 400, $color-grey);
      }
    }   
  }
</style>
